import store from '@/states/index.js'

import ProjectPlanner from '../ProjectPlanner.vue'

export default [
    {
        path: '/projectplanner',
        component: ProjectPlanner,
        name: 'projectplanner',
        beforeEnter: (to, from, next) => {
            const role = store.getters['auth/getuser']
            if(role.info.role === 3){
                next()
            }else{
                next('/')
            }
            return
        }
    }
]